import { AppThunkDispatch, RootState } from '../..';
import { rejectItemCategoryRecommendationApi } from '../api/items';
import {
  getItemCategoryRecommendationNodeItems,
  removeItemCategoryRecommendationNodes,
} from './itemCategoryRecommendationTree';
import type { NodeBaseItem } from '../../../entities/Node';

export const rejectItemCategoryRecommendation = (
  tree: string,
  nodeItem: NodeBaseItem,
) => {
  return async (dispatch: AppThunkDispatch, getState: () => RootState) => {
    const nodeItems = getItemCategoryRecommendationNodeItems(nodeItem, getState);
    if (!nodeItems.length) return undefined;

    const ids = nodeItems
      .map((ni: NodeBaseItem) => ni.node.item.itemCategoryRecommendationId)
      .filter((id): id is number => id !== undefined);
    await dispatch(rejectItemCategoryRecommendationApi(ids)).unwrap();

    return dispatch(removeItemCategoryRecommendationNodes(tree, nodeItems));
  };
};
